import {type FC, useRef} from 'react';
import type {BusArrivalInfo} from '../types';
import {CardWrapper, Header, Row, Table, Tbody, Thead, Title} from '../types/BusInfo.styled.ts';
import {secondToMinute} from '../../../utils/DateUtil.ts';
import BusR from '../../../assets/bus/bus-R.svg';
import BusB from '../../../assets/bus/bus-B.svg';
import BusGY from '../../../assets/bus/bus-GY.svg';
import {getCurrentFocusKey, setFocus, useFocusable} from '@noriginmedia/norigin-spatial-navigation';

interface BusCardProps {
    direction: 'left' | 'right';
    stationName: string;
    highlightBusNumber: string[];
    buses: BusArrivalInfo[];
}

const BusCard: FC<BusCardProps> = ({direction, stationName, highlightBusNumber, buses}) => {
    const scrollContainerRef = useRef<HTMLDivElement>(null);

    const {ref: busCardRef, focused} = useFocusable({
        focusKey: `bus-card-${direction}`,
        onArrowPress: (direction) => {
            if (focused && scrollContainerRef.current) {
                const container = scrollContainerRef.current;
                const scrollAmount = 100;

                if (direction === 'up') {
                    const isAtTop = container.scrollTop === 0;
                    if (isAtTop) {
                        setFocus('bus-back-button');
                        return false;
                    }
                    container.scrollTop = Math.max(0, container.scrollTop - scrollAmount);
                    return false;
                    // container.scrollTop = Math.max(0, container.scrollTop - scrollAmount);
                } else if (direction === 'down') {
                    container.scrollTop = Math.min(
                        container.scrollHeight - container.clientHeight,
                        container.scrollTop + scrollAmount
                    );
                    return false;
                } else if (direction === 'left') {
                    if (getCurrentFocusKey() === 'bus-card-left') {
                        setFocus('busArrived');
                    }
                }
            }
            return true;
        },
    });

    return (
        <CardWrapper ref={busCardRef} $focused={focused} $direction={direction}>
            <Title>{stationName}</Title>
            <Header $direction={direction}>
                <div>곧 도착</div>
                <div>
                    {highlightBusNumber.map((num, idx) => (
                        <span key={idx}>
                            <img
                                src={direction === 'left' ? BusR : BusB}
                                alt="버스"
                                style={{width: '1.2rem', height: '1.2rem', marginRight: '0.25rem'}}
                            />
                            {num}
                        </span>
                    ))}
                </div>
            </Header>
            <Table ref={scrollContainerRef} $direction={direction}>
                <Thead $direction={direction}>
                    <div className="table-row">
                        <div className="table-cell">버스 번호</div>
                        <div className="table-cell">남은 시간</div>
                        <div className="table-cell">남은 정거장</div>
                    </div>
                </Thead>
                <Tbody>
                    {buses.map((bus, index) => (
                        <Row key={index} $highlight={highlightBusNumber.includes(bus.ROUTENO)} $direction={direction}>
                            <div className="table-cell">
                                <img src={BusGY} alt="버스" /> {bus.ROUTENO}
                            </div>
                            <div className="table-cell">
                                <span className="remainMinute">{secondToMinute(bus.ARRIVALESTIMATETIME)}</span> 분
                            </div>
                            <div className="table-cell">{bus.REST_STOP_COUNT} 정거장</div>
                        </Row>
                    ))}
                </Tbody>
            </Table>
        </CardWrapper>
    );
};

export default BusCard;
